import { render, staticRenderFns } from "./VImageCard.vue?vue&type=template&id=93a71908&scoped=true&"
import script from "./VImageCard.vue?vue&type=script&lang=js&"
export * from "./VImageCard.vue?vue&type=script&lang=js&"
import style0 from "./VImageCard.vue?vue&type=style&index=0&id=93a71908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a71908",
  null
  
)

export default component.exports